import { Navigate, Route } from 'react-router-dom'
import { LegacyAliasRedirect } from '@/pages/shared/LegacyAliasRedirect'
import { LadderHubRedirect } from '@/pages/shared/LadderHubRedirect'
import {
  LegacyCreateTournamentAliasRedirect,
  LegacyProfileHtmlRedirect,
  LegacyTournamentsHtmlRedirect,
} from '@/pages/shared/LegacyHtmlRedirects'

export function legacyRedirectRoutes() {
  return (
    <>
      <Route
        path="/tournaments/view"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            fallbackTo="/tournaments"
          />
        }
      />
      <Route
        path="/ladders/view"
        element={
          <LegacyAliasRedirect
            idParam="ladderId"
            destinationBase="/ladders"
            fallbackTo="/ladders"
          />
        }
      />
      <Route path="/public-tournaments.html" element={<Navigate to="/tournaments" replace />} />
      <Route path="/public-ladders.html" element={<Navigate to="/ladders" replace />} />
      <Route
        path="/public-tournament.html"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            fallbackTo="/tournaments"
          />
        }
      />
      <Route
        path="/public-ladder.html"
        element={
          <LegacyAliasRedirect
            idParam="ladderId"
            destinationBase="/ladders"
            fallbackTo="/ladders"
          />
        }
      />
      <Route path="/ladder.html" element={<LadderHubRedirect />} />
      <Route path="/create-ladder.html" element={<LadderHubRedirect forceCreate />} />
      <Route path="/create-tournament.html" element={<LegacyCreateTournamentAliasRedirect />} />
      <Route
        path="/ladder-manage.html"
        element={
          <LegacyAliasRedirect
            idParam="ladderId"
            destinationBase="/ladders"
            destinationSuffix="/manage"
            fallbackTo="/ladders"
          />
        }
      />
      <Route
        path="/ladders/manage"
        element={
          <LegacyAliasRedirect
            idParam="ladderId"
            destinationBase="/ladders"
            destinationSuffix="/manage"
            fallbackTo="/ladders"
          />
        }
      />
      <Route path="/workspace.html" element={<Navigate to="/workspace" replace />} />
      <Route path="/tournament.html" element={<LegacyAliasRedirect idParam="tournamentId" destinationBase="/tournaments" fallbackTo="/workspace" />} />
      <Route path="/tournaments.html" element={<LegacyTournamentsHtmlRedirect />} />
      <Route path="/clubs.html" element={<Navigate to="/clubs" replace />} />
      <Route path="/index.html" element={<Navigate to="/" replace />} />
      <Route path="/profile.html" element={<LegacyProfileHtmlRedirect />} />
      <Route path="/admin.html" element={<Navigate to="/admin" replace />} />
      <Route path="/tournaments/new.html" element={<Navigate to="/tournaments/new" replace />} />
      <Route
        path="/edit-tournament.html"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route
        path="/tournaments/editor.html"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route
        path="/tournaments/edit.html"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route
        path="/editor"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route
        path="/tournaments/edit"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route
        path="/edit"
        element={
          <LegacyAliasRedirect
            idParam="tournamentId"
            destinationBase="/tournaments"
            destinationSuffix="/edit"
            fallbackTo="/tournaments/new"
          />
        }
      />
      <Route path="/players.html" element={<Navigate to="/players" replace />} />
      <Route path="/organization.html" element={<Navigate to="/organization" replace />} />
      <Route path="/all-players.html" element={<Navigate to="/players/all" replace />} />
      <Route path="/create-player.html" element={<Navigate to="/players/new" replace />} />
      <Route
        path="/player.html"
        element={<LegacyAliasRedirect idParam="playerId" destinationBase="/players" fallbackTo="/players" />}
      />
      <Route
        path="/player-edit.html"
        element={
          <LegacyAliasRedirect idParam="playerId" destinationBase="/players/edit" fallbackTo="/players" />
        }
      />
      <Route
        path="/players/view"
        element={<LegacyAliasRedirect idParam="playerId" destinationBase="/players" fallbackTo="/players" />}
      />
    </>
  )
}
